import React from "react";
import { Trans } from "react-i18next";

export const EmptyState = ({ searchTerm }) => (
  <div className="emptystate-wrapper is-shown">
    <h2>
      <Trans>No Orders {searchTerm && ' Found'}</Trans>
    </h2>

    <img src="images/emptystate-icons/newvehicle-emptystate-icon.png" style={{ height: "78px" }} />

    {!searchTerm && (
      <p className="mb-16"><Trans>Looks like you haven't added any Orders yet.</Trans></p>
    )}
  </div>
);
